import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Navbar.css';
import navlogo from '../Assets/finallogo.png';
import navprofileIcon from '../Assets/logout.svg';
import { useAdminMode } from '../../context/AdminModeContext';
import { hasBoutiqueAccess, hasRetailAccess, getModeHomePath } from '../../utils/menuAccess';

const Navbar = () => {
  const { mode, setMode } = useAdminMode();
  const navigate = useNavigate();
  // Plain synchronous read on every render — Navbar lives outside the routed
  // tree and never remounts on login/logout, so cached state here would go
  // stale. This re-evaluates correctly whenever anything (e.g. setMode below)
  // triggers a re-render, including right after login.
  const isLoggedIn = !!sessionStorage.getItem("adminToken");

  const handleLogout = () => {
    sessionStorage.removeItem("adminToken");
    window.location.href = "/admin/login";
  };

  const switchMode = (next) => {
    if (next === mode) return;
    setMode(next);
    navigate(getModeHomePath(next) || "/admin/login");
  };

  // Only show the switch when the user has menus in both modes
  const showModeSwitch = isLoggedIn && hasRetailAccess() && hasBoutiqueAccess();

  return (
    <div className='navbar'>
      <img src={navlogo} className='nav-logo' alt="Logo" />
      <h1>Aavryaa's Admin Panel</h1>

      {showModeSwitch && (
        <div className="nav-mode-switch" role="tablist" aria-label="Admin panel mode">
          <button
            role="tab"
            aria-selected={mode === "retail"}
            className={`nav-mode-btn ${mode === "retail" ? "active" : ""}`}
            onClick={() => switchMode("retail")}
          >
            Retail
          </button>
          <button
            role="tab"
            aria-selected={mode === "boutique"}
            className={`nav-mode-btn ${mode === "boutique" ? "active" : ""}`}
            onClick={() => switchMode("boutique")}
          >
            Boutique
          </button>
        </div>
      )}

      {isLoggedIn && (
        <img
          src={navprofileIcon}
          className='nav-profile'
          alt="Logout"
          onClick={handleLogout}
          title="Logout"
          style={{ cursor: "pointer" }}
        />
      )}
    </div>
  );
};

export default Navbar;
